import React from 'react';
import {
  Box,
  Typography
} from '@mui/material';

const Footer = () => {
  return (
    <Box
      sx={{
        py: { xs: 3, md: 4 },
        backgroundColor: '#f8f9fa',
        borderTop: '1px solid #e9ecef',
        textAlign: 'center'
      }}
    >
      <Box sx={{ maxWidth: '1200px', mx: 'auto', px: { xs: 2, sm: 3 } }}>
        <Typography
          variant="body2"
          sx={{
            fontSize: { xs: '0.85rem', md: '0.9rem' },
            fontWeight: 400,
            color: '#6c757d',
            lineHeight: 1.5
          }}
        >
          © {new Date().getFullYear()} GlowWorks - Built with love for the Beauty Industry
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
